/* istanbul ignore file */

import React from 'react';
import { useMinBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import { BreakPoints } from '@constants/breakpoints';

interface IShowAtProps {
  breakpoint: BreakPoints;
  children: any;
}

export default function ShowAt({
  breakpoint,
  children,
}: IShowAtProps) {
  const targetReached = useMinBreakpoint(breakpoint);

  return (
    <>
      {targetReached ? children : null}
    </>
  );
}
